import * as React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Helmet from 'react-helmet'
import { GlobalProvider } from 'components/Store'
import Header from 'components/header/Header'
import Footer from 'components/footer/Footer'

const DefaultLayout = ({
	title,
	description,
	noindex,
	className,
	transparentHeader,
	children,
}) => {
	const {
		sanitySite,
		allSanityProjectType,
		allSanityProjectWithLocation,
		allSanityFeaturedLocation,
	} = useStaticQuery(query)

	const value = {
		projectTypes: allSanityProjectType.nodes,
		projects: allSanityProjectWithLocation.nodes,
		featuredLocations: allSanityFeaturedLocation.nodes,
	}

	return (
		<>
			<Helmet
				titleTemplate={`%s | ${sanitySite.title}`}
				htmlAttributes={{ lang: 'en' }}
			>
				{title && <title>{title}</title>}
				{description && <meta name="description" content={description} />}
				<link rel="icon" href="/fastech-favicon.svg" type="image/svg+xml" />
				{noindex && <meta name="robots" content="noindex" />}
			</Helmet>

			<GlobalProvider values={value}>
				<Header transparent={transparentHeader} />

				<main className={className}>{children}</main>

				<Footer />
			</GlobalProvider>
		</>
	)
}

export default DefaultLayout

const query = graphql`
	query DefaultLayout {
		sanitySite {
			title
		}
		allSanityProjectType(sort: { fields: orderRank }) {
			nodes {
				name
				category
				color
			}
		}
		allSanityProjectWithLocation {
			nodes {
				_id
				company
				description
				type {
					name
					color
				}
				isHydrogenFuel
				city
				location {
					lat
					lng
				}
				caseStudy {
					title
					seo {
						slug {
							current
						}
					}
				}
			}
		}
		allSanityFeaturedLocation(sort: { fields: orderRank }) {
			nodes {
				name
				location {
					lat
					lng
				}
			}
		}
	}
`
